import React from "react";

export default function MetricGuardrailsView() {
  return <></>;
}
